import { makeStyles } from '@mui/styles';
import Table from 'apollo-react/components/Table';
import Typography from 'apollo-react/components/Typography';
import { AiSparkles } from 'apollo-react-icons';
import React from 'react';
import { useSelector } from 'react-redux';

import NavigateLinkCell from '../../containers/FindPage/NavigateLinkCell';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getAppSettingsByKey } from '../../selectors/AppConfigsSelectors';
import { checkTrue, getUITA } from '../../utils/commonUtils';
import { dataTypeFormatters } from '../../utils/savedSearchUtils';
import { SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { RECORD_SIMILARITY_APP_SETTING_KEY } from '../constants/runtime.constants';
import {
  getIsSimilarRecordsDataFetched,
  getSimilarRecordsByControlId,
} from '../selectors/common.selectors';

const useStyles = makeStyles({
  similarRecordsTable: {
    marginTop: 15,
  },
  editorControlContainer: {
    display: 'flex',
    paddingLeft: 15,
  },
});

const SSSimilarRecords = ({ isEditor, id }) => {
  const translateString = useTranslation();
  const classes = useStyles();

  const { columns = [], rows = [] } = useFormSelector(getSimilarRecordsByControlId, {
    controlId: id,
  });
  const isSimilarRecordsDataFetched = useFormSelector(getIsSimilarRecordsDataFetched);
  const isSimilarityServiceEnabled = useSelector(
    getAppSettingsByKey(RECORD_SIMILARITY_APP_SETTING_KEY)
  );

  if (isEditor) {
    return (
      <div className={classes.editorControlContainer}>
        <Typography style={{ marginRight: 15 }}>{SS_CONTROL_TYPE.AI_SIMILAR_RECORDS}</Typography>
        <AiSparkles color="primary" />
      </div>
    );
  }

  if (!checkTrue(isSimilarityServiceEnabled)) {
    return null;
  }

  const navColumnAccessor = rows[0]?.NavigationColumn || '';

  const buildCustomCell = (column) => {
    if (navColumnAccessor === column.accessor) {
      return ({ row, column }) => NavigateLinkCell.savedSearchColumnLink(column)({ row });
    }

    const formatter = dataTypeFormatters[column.dataType];

    if (formatter) {
      const formatValue = (row) => {
        const formattedValue = formatter(row[column.accessor], row[column.formatType]) || '';

        return column.accessor === 'confidence' ? `${formattedValue}%` : formattedValue;
      };

      const CustomCell = ({ row }) => <>{formatValue(row)}</>;
      return CustomCell;
    }

    return null;
  };

  const customColumns = columns.map((column) => ({
    ...column,
    customCell: buildCustomCell(column),
  }));

  return (
    <div className={classes.similarRecordsTable} ui-ta={getUITA('FormCtrl', 'SSSimilarRecords')}>
      <Table
        rows={rows}
        columns={customColumns}
        rowId={navColumnAccessor}
        hasScroll
        isLoading={!isSimilarRecordsDataFetched}
        emptyProps={{
          text: translateString('No data to display'),
        }}
        rowProps={{ 'ui-ta': 'similar-records-row' }}
        hidePagination
      />
    </div>
  );
};

export default SSSimilarRecords;
